module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M3 10a1 1 0 0 0 1-1V4h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H2C.894 0 0 .894 0 2v7a1 1 0 0 0 1 1h2zm1 13a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v7c0 1.106.894 2 2 2h7a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H4v-5zm25-1a1 1 0 0 0-1 1v5h-5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h7c1.106 0 2-.894 2-2v-7a1 1 0 0 0-1-1h-2zM23 0a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2c0-1.106-.894-2-2-2h-7z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/marquee-2.js
// module id = 1259
// module chunks = 14